import { useState, FC } from "react";
import styles from "./FlightContainer.module.scss";
// import {FlightCard} from "./FlightCard";
import {FlightCardNew} from "./FlightCardNew";
import type {FlightContainerProps} from "../types/flight";
import { durationMinutes } from "./flightPresentation";

type FlightTab = "Best Value" | "Cheapest" | "Fastest";

export const FlightContainer: FC<FlightContainerProps> = ({ flights }) => {
    const [activeTab, setActiveTab] = useState<FlightTab>("Best Value");
    const tabs: FlightTab[] = ["Best Value", "Cheapest", "Fastest"];
    const flightPrice = (flight: any): number => {
        const direct = Number(String(flight?.price || '').replace(/[^0-9.]/g, ''));
        if (!Number.isNaN(direct) && direct > 0) return direct;
        const offerPrice = Number(flight?.price?.total ?? flight?.total_amount ?? flight?.price?.base ?? 0);
        return Number.isNaN(offerPrice) ? Number.POSITIVE_INFINITY : offerPrice;
    };
    /* Compared as parsed minutes, not as the raw ISO string -- sorting those
       as text puts PT9H after PT10H. */
    const flightDuration = (flight: any): number => {
        return durationMinutes(
            String(flight?.duration || flight?.itineraries?.[0]?.duration || flight?.slices?.[0]?.duration || ''),
        );
    };
    const sortedFlights = [...flights].sort((a, b) => {
        if (activeTab === "Cheapest") {
            return flightPrice(a as any) - flightPrice(b as any);
        }

        if (activeTab === "Fastest") {
            return flightDuration(a as any) - flightDuration(b as any);
        }

        return 0; // Best Value (placeholder logic)
    });
    return (
        <div className={styles.flightContainer}>
            <div className={styles.tabsContainer}>
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        className={[
                            styles.tabButton,
                            activeTab === tab && styles.active
                        ]
                            .filter(Boolean)
                            .join(" ")}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            <div className={styles.flightList}>
                {/* <FlightCard key={flight.id} flight={flight} /> */}
                {sortedFlights.map((flight) => (
                    <FlightCardNew key={flight.id} flight={flight as any} />
                ))}
            </div>
        </div>
    );
};
